var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersOliJan22(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 130",
    style: {
      enableBackground: "new 0 0 130 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10.0001;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.09,64.43c2.7-7.87,7.35-15.47,13.88-22c19.94-19.94,49.89-22.32,66.9-5.32s14.62,46.95-5.32,66.9 s-49.89,22.32-66.9,5.32c-2.38-2.38-4.39-5.02-6.01-7.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 49.64,
    y1: 39.93,
    x2: 44.93,
    y2: 34.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24.58,
    y1: 20.04,
    x2: 52.72,
    y2: 20.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.79,
    y1: 58.61,
    x2: 22.29,
    y2: 58.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.93,
    y1: 74.25,
    x2: 48,
    y2: 74.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.79,
    y1: 94.61,
    x2: 55.43,
    y2: 94.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 82.65,
    y1: 69.33,
    x2: 102.36,
    y2: 51.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.79,20.04c0,0,8.84,6.43,13.42,11.79"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30.11,
    y1: 75.25,
    x2: 30.11,
    y2: 83.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.93,
    y1: 113.47,
    x2: 29.08,
    y2: 113.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.81,71.59c0,0-0.44,17.16-15.17,28.45s-27.16,11.17-27.16,11.17"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7636 -0.6457 0.6457 0.7636 -28.9107 67.4795)",
    className: "st1",
    cx: 77.7,
    cy: 73.22,
    rx: 5.79,
    ry: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.86,17.47H78.58c-2.25,0-4.07-1.82-4.07-4.07l0,0c0-2.25,1.82-4.07,4.07-4.07h16.29 c2.25,0,4.07,1.82,4.07,4.07l0,0C98.93,15.65,97.11,17.47,94.86,17.47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersOliJan22);
export default __webpack_public_path__ + "static/media/users_oli_Jan_22.a260a265bf696f1d94a199935b83e5d9.svg";
export { ForwardRef as ReactComponent };